var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary btn-lg",attrs:{"disabled":_vm.disabled},on:{"click":_vm.submit}},[_vm._v("\n  "+_vm._s(_vm.lang.get('buttons.save'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }